<div
  class="flex align-items-center py-1 px-2 text-sm border-round-sm gap-2 w-max"
  [ngClass]="selectable ? 'cursor-pointer' : ''"
  [style]="{
    background: bgColor,
    color: fgColor,
    cursor: 'default'
  }"
  (click)="selectable ? onSelectPlan() : ''" 
>
  {{ planName }}
  <p-badge *ngIf="available !== null" [value]="available" class="white-badge"/>
</div>
